import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SuiviData } from './suivi-general-permanente/suivi-general-permanente.component';

export interface SuiviDetail {
  typStruct: string;
  nomStruct: string;
  etape: string;
  niveauErreur: string;
  ielst: string;
}

@Injectable({
  providedIn: 'root'
})
export class SuiviSaisieService {
  // Pour enquete permanente
  private urlGeneral: string;
  private urlDetail: string;
  public formulaire: UntypedFormGroup;
  public ongletIndex: number = 0;

  constructor(
    private http: HttpClient,
    @Inject('API_URL') private apiUrl: string
    ) {
    // Pour enquete permanente
    this.urlGeneral = apiUrl + '/suivi/saisie';
    this.urlDetail = apiUrl + '/suivi/detail';

    // Pour enquete permanente
    this.formulaire = new UntypedFormGroup(
      {
          etape: new UntypedFormControl(''),
          niveauErreur: new UntypedFormControl('')
      }
    );

  }


  // Pour enquete permanente
  // ***********************
            // Suivi Général
            public getSuiviNbRepondant$(): Observable<SuiviData[]> {
              return this.http.get<SuiviData[]>(this.urlGeneral)
                .pipe(catchError((erreur: any) => {
                  let messageErreur = '';
                  if (erreur.error instanceof ErrorEvent) {
                    messageErreur = erreur.error.message;
                  } else {
                    // Erreur provenant du serveur
                    messageErreur = `Code d’erreur : ${erreur.status}\nMessage: ${erreur.message}`;
                  }
                  return throwError(messageErreur);
                }));
            }

            // Suivi détail avec parametre
            public getSuiviDetail$(filtreEtape: string, filtreNiveauErreur: string): Observable<SuiviDetail[]> {
              let httpParams = new HttpParams();
              if (filtreEtape && filtreEtape !== '') {
                httpParams = httpParams.set('etape', filtreEtape);
              }
              if (filtreNiveauErreur && filtreNiveauErreur !== '') {
                httpParams = httpParams.set('niveauErreur', filtreNiveauErreur);
              }
              return this.http.get<SuiviDetail[]>(this.urlDetail, { params: httpParams })
                .pipe(catchError((erreur: any) => {
                  let messageErreur = '';
                  if (erreur.error instanceof ErrorEvent) {
                    messageErreur = erreur.error.message;
                  } else {
                    // Erreur provenant du serveur
                    messageErreur = `Code d’erreur : ${erreur.status}\nMessage: ${erreur.message}`;
                  }
                  return throwError(messageErreur);
                }));
            }
}


